var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourcing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 56,
    viewBox: "0 0 54 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.2902 32.9192C20.0683 32.9192 16.9187 31.9638 14.2398 30.1738C11.5609 28.3838 9.47298 25.8396 8.24002 22.863C7.00706 19.8864 6.68446 16.6109 7.31302 13.451C7.94158 10.291 9.49306 7.38837 11.7713 5.11015C14.0495 2.83193 16.9521 1.28044 20.1121 0.651885C23.2721 0.0233262 26.5475 0.345925 29.5241 1.57889C32.5008 2.81185 35.0449 4.8998 36.8349 7.5787C38.6249 10.2576 39.5803 13.4071 39.5803 16.629C39.5756 20.948 37.8578 25.0887 34.8038 28.1427C31.7498 31.1966 27.6091 32.9144 23.2902 32.9192Z",
    fill: "url(#paint0_linear_245_93647)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5271 17.9498C39.0907 17.8766 38.6427 17.9182 38.2272 18.0704C37.8117 18.2227 37.4429 18.4803 37.1569 18.818C36.3652 19.7124 35.2787 19.2709 33.5177 16.0227C31.8301 12.9129 33.376 11.5445 33.9918 9.64343C34.5179 8.08772 33.1023 4.17646 32.2324 3.0166L32.2487 3.03289C34.5014 4.51444 36.3507 6.53241 37.6305 8.9055C38.9103 11.2786 39.5805 13.9325 39.5809 16.6286C39.5809 17.0685 39.5646 17.5246 39.532 17.9481L39.5271 17.9498Z",
    fill: "#2DC0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0699 32.4793C25.8321 32.7757 24.5633 32.9234 23.2905 32.9192C22.7204 32.9192 22.1665 32.8866 21.6127 32.8377C22.0325 31.5345 21.9452 30.1209 21.3683 28.8792C20.1628 27.0873 17.0351 27.0547 16.9211 24.7904C16.998 23.4646 16.9598 22.1347 16.8071 20.8156C16.4976 19.5124 8.53167 18.9194 8.93892 8.94984V8.94006C10.3284 6.34148 12.3973 4.16886 14.9248 2.65405C17.4524 1.13923 20.3438 0.339042 23.2905 0.338867C24.4455 0.34099 25.5972 0.461075 26.7278 0.69725C26.7166 1.35148 26.4983 1.98532 26.1044 2.50776C25.7104 3.0302 25.161 3.41435 24.5351 3.60504C19.9283 5.11351 23.6033 11.1181 20.5375 11.7501C19.5194 11.9586 17.7812 10.2482 16.8038 10.4844C16.55 10.5355 16.3151 10.6552 16.1245 10.8305C15.9339 11.0058 15.795 11.2299 15.7228 11.4785C15.6507 11.7271 15.648 11.9908 15.715 12.2408C15.7821 12.4909 15.9164 12.7178 16.1033 12.8969C17.488 14.3321 16.8364 14.886 17.343 16.0442C17.8496 17.2024 19.4607 17.3376 21.3634 17.121C23.2661 16.9043 24.1213 16.8066 25.4604 18.201C26.7994 19.5954 26.529 21.5666 28.4105 21.7848C30.292 22.0031 32.4293 22.8437 32.1573 24.4548C31.7777 26.7077 27.6107 27.8953 27.065 32.4793",
    fill: "#2DC0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_245_93647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1571 40.3026C53.0439 40.4163 52.9093 40.5065 52.7612 40.568C52.613 40.6296 52.4541 40.6612 52.2937 40.6612C52.1333 40.6612 51.9744 40.6296 51.8262 40.568C51.6781 40.5065 51.5435 40.4163 51.4303 40.3026L44.3115 33.1838C44.9427 32.6666 45.5211 32.0882 46.0383 31.457L53.1571 38.5758C53.3843 38.8057 53.5117 39.116 53.5117 39.4392C53.5117 39.7624 53.3843 40.0727 53.1571 40.3026Z",
    fill: "#2EC0FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_245_93647)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.8182,
    cy: 23.5565,
    r: 12.2176,
    fill: "#D9D9D9",
    fillOpacity: 0.07
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_245_93647",
    x: 0.510586,
    y: 2.64887,
    width: 53.0011,
    height: 53.3023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -12.1,
    dy: 3.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.995
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_245_93647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_245_93647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_245_93647",
    x: 4.60059,
    y: -8.66113,
    width: 64.4355,
    height: 64.4355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_245_93647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_245_93647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_93647",
    x1: 23.2901,
    y1: 0.338867,
    x2: 23.2901,
    y2: 32.9192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6DA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourcing);
export default __webpack_public_path__ + "static/media/Sourcing.be3cb4872e766b32f1088ea779989b82.svg";
export { ForwardRef as ReactComponent };